export default "__VITE_ASSET__K1mNvhgk__"